import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {connectForm} from '../../core/redux/form'
import {replace} from '../../core/extract'
import Icon from '../../core/components/Icon'
import Selector from '../../core/components/Selector'
import {queryActivityRef} from '../../reference/actions'
import {DEFAULT_CONTACT_QUERY, CONTACT_MINOR_CRITERIA_UPDATED, queryContactStream, updateContactMinorCriteria, resetContactMinorCriteria} from '../actions'
import {ContactCriteria, resolveActivities} from '../models'
import i18n from '../i18n'
import style from './ContactSelector.less'

class ContactSelector extends Component {
    static propTypes = {
        company: PropTypes.object.isRequired
    }

    componentWillMount() {
        const {dispatch, company} = this.props

        dispatch(resetContactMinorCriteria())
        dispatch(queryContactStream({...DEFAULT_CONTACT_QUERY, companyUid: company.uid, range: {offset: 0, limit: 99}}))
        dispatch(queryActivityRef())
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.company != nextProps.company) {
            const {dispatch, company} = nextProps

            dispatch(resetContactMinorCriteria())
            dispatch(queryContactStream({...DEFAULT_CONTACT_QUERY, companyUid: company.uid, range: {offset: 0, limit: 99}}))
        }
    }

    _search(event) {
        const {dispatch, minorCriteria} = this.props

        event.preventDefault()
        dispatch(queryContactStream(minorCriteria))
    }

    _searchOnKeyPress(event) {
        if (event.key == 'Enter') {
            const {dispatch, minorCriteria} = this.props
            dispatch(queryContactStream(minorCriteria))
        }
    }

    _clear(event) {
        const {dispatch, minorCriteria} = this.props

        event.preventDefault()
        dispatch(updateContactMinorCriteria({fullText: null}))
        dispatch(queryContactStream({...minorCriteria, fullText: null}))
    }

    render() {
        const {dispatch, form, company, reference, minorCriteria, stream, range, query, ...others} = this.props

        const searched = minorCriteria && minorCriteria.fullText && minorCriteria.fullText == (query && query.fullText)

        const header = (
            <div className={style.search}>
                {searched && (
                    <a
                        href=''
                        onClick={(e) => this._clear(e)}>
                        <Icon icon='cross' size='xs' />
                    </a>
                )}
                {!searched && (
                    <a
                        href=''
                        onClick={(e) => this._search(e)}>
                        <Icon icon='search' size='xs' />
                    </a>
                )}
                <div className={style.container}>
                    <input
                        type='text'
                        onKeyPress={(e) => this._searchOnKeyPress(e)}
                        placeholder={i18n.searchStream.xs}
                        {...form.fullText()} />
                </div>
            </div>
        )

        const afterContacts = () => {
            if (range && (range.limit < range.count - 1)) {
                const count = range.limit + 1
                return (
                    <p>{replace(i18n.useSearchProviderContactFilters, {count})}</p>
                )
            }
        }

        const displayContact = (contact) => (
            <div className={style.contact}>
                <p>{contact.name.firstName} {contact.name.lastName} {contact.name.value}</p>
                <p>
                    {resolveActivities(reference, contact.activities).map((activity, index) => (
                        <small
                            key={index}>
                            {index > 0 && (<span> - </span>)}
                            <span>{activity.label}</span>
                        </small>
                    ))}
                </p>
            </div>
        )

        return (
            <div className={style.default}>
                <Selector
                    source={stream}
                    identify={(c) => c.uid}
                    display={displayContact}
                    header={header}
                    after={afterContacts()}
                    {...others} />
            </div>
        )
    }
}

ContactSelector = connectForm({
    target: 'minorCriteria',
    schema: ContactCriteria.schema,
    action: CONTACT_MINOR_CRITERIA_UPDATED
})(ContactSelector)

ContactSelector = connect((state) => ({
    reference: state.reference.activityRef,
    minorCriteria: state.provider.contact.minorCriteria,
    stream: state.provider.contact.stream,
    range: state.provider.contact.range,
    query: state.provider.contact.query
}))(ContactSelector)

export default ContactSelector


// WEBPACK FOOTER //
// ./lib/provider/components/ContactSelector.js